module.exports = require('./dist/calculate-house-value');
